module.exports = __webpack_public_path__ + "img/nyc-bg.5adfbbee.jpg";